<style lang="scss">
@import './base.scss';
@import './user-behavior.scss';
</style>
<template>
  <div class="user-behavior module-wrap clearfix">
    <!-- 模块名称 -->
    <h3 class="module-label">{{ $t('userBehavior.behavior') }}</h3>
    <!-- 模块关系 -->
    <expr-relation
      v-if="moduleItemName.length > 0"
      :relation="behavior.relation"
      @on-choice-relation="choiceRelation"></expr-relation>
    <div class="module-content">
      <div v-for="(key, ind) in moduleItemName" class="module-content-item-box" :key="key">
        <!-- 连接线：只有第一个和最后一个显示 -->
        <connecting-line
          v-if="ind === 0 || ind === items.length - 1"
          :end-line="ind === items.length - 1"></connecting-line>
        <module-item
          :ref="key"
          :item-key-name="key"
          :item-name="selectItem[key].title"
          :date-move="noDateRange.indexOf(key) === -1"
          :content-data="saveRawData[key]"
          @on-remove-item="removeItems"
          @on-change-item="changeItems">
            <div slot="itemContent" style="padding-left: 45px;">
              <events-item
                v-if="key === 'customevent' || key === 'page_view' || key === 'launch_info'"
                :ref="key"
                :o-caller-type="key"
                :expr-data="itemExprData"
                :item-expr="typeName[key]"
                :backup-data="itemBackup[key]"></events-item>
            </div>
          </module-item>
      </div>
      <!-- 添加选项按钮 -->
      <div
        v-if="moduleItemName.length < items.length"
        class="module-content-item-box"
        :style="{'padding-top': [moduleItemName.length > 0 ? '10px' : '20px']}">
        <!-- 添加选项按钮连接线 -->
        <connecting-line
          v-if="moduleItemName.length > 0"
          btn-line></connecting-line>
        <Dropdown
          trigger="click"
          class="user-behavior-ivu-btn"
          @on-click="addItemBox">
            <a href="javascript:void(0)">
              <Select :placeholder="$t('userBehavior.addPlaceholder')" class="user-behavior-ivu-btn"></Select>
            </a>
          <Dropdown-menu slot="list">
            <Dropdown-item
              v-for="key in items"
              v-show="moduleItemName.indexOf(key) === -1"
              :name="key"
              :key="key">{{ selectItem[key].title }}</Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
      </div>
    </div>
  </div>
</template>
<script>
  import connectingLine from './connecting-line';
  import exprRelation from './expr-relation';
  import moduleItem from './behavior-item';
  import userLang from '../../libs/usergroup-item-base';
  import eventsItem from './user-events';
  import bus from '../../libs/bus';

  export default {
    components: {
      moduleItem,
      eventsItem,
      exprRelation,
      connectingLine,
    },
    props: {
      moduleItems: Array,
      behaviorExpr: Object,
      itemList: Object,
      itemBackup: Object,
      rawData: Object,
    },
    data() {
      return {
        itemExprData: {
          relation: '',
          expr: {},
          detail: {},
        },
        // 目前不支持 useTimes使用时长 startTimes启动次数
        items: ['lostDays', 'customevent', 'page_view', 'launch_info'],
        // 支持选择多个条件的类型名称
        noDateRange: ['lostDays', 'customevent', 'page_view', 'launch_info'],
        selectItem: userLang.changeBehaviorLang(),
        moduleItemName: [],
        detailName: {
          lost_user: 'userBehavior.lostDays',
        },
      };
    },
    computed: {
      tempModuleItem() {
        return this.moduleItems;
      },
      behavior() {
        return this.behaviorExpr;
      },
      saveRawData() {
        return this.rawData;
      },
      typeName() {
        return this.itemList;
      },
    },
    watch: {
      tempModuleItem: {
        handler(val) {
          this.moduleItemName = val;
          this.setBehaviorExpr();
        },
        deep: true,
      },
    },
    mounted() {
      bus.$on('on-change-lang', this.changeLang);
    },
    beforeDestroy() {
      bus.$off('on-change-lang', this.changeLang);
    },
    methods: {
      //切换中英文
      changeLang() {
        this.selectItem = userLang.changeBehaviorLang();
      },
      /**
       * 设置创建或编辑的表达式
       * @return [{Object}]
       */
      setBehaviorExpr() {
        this.behavior.expr = this.moduleItemName.map(x => this.saveRawData[x])
          .filter(x => x !== undefined);

        this.behavior.expr.forEach((item) => {
          const key = Object.keys(item)[0];
          if (key === 'lost_user') {
            const textObj = this.detailName[key];
            const textA = this.$t(`${textObj}.info.a`);
            const textB = this.$t(`${textObj}.info.b`);
            // const unit = this.$t(`${textObj}.unit`);

            this.behavior.detail.lostDays = `${textA}${item.lost_user.lostDays.$gt}${textB}`;
          }
        });
      },
      /**
       * 删除当前选项
       * @param  {[String]} key [当前项 itemKeyName]
       */
      removeItems(key) {
        this.moduleItemName.splice(this.moduleItemName.indexOf(key), 1);
        if (key === 'lostDays') {
          // saveRawData ==> 非事件，页面，活跃的数据清除方式
          delete this.saveRawData[key];
        } else {
          // typeName ==> 事件，页面，活跃的数据清除方式
          this.typeName[key].detail = [];
          this.typeName[key].expr = [];
          this.typeName[key].relation = '$and';
          this.typeName[key].errorStatus = false;
        }
        this.setBehaviorExpr();
      },
      /**
       * 当选项中参数修改时更改上传的数据
       * @param  {[String]} key [当前项 itemKeyName]
       * @param {[Object]} obj [当前修改后的所有数据]
       */
      changeItems(key, obj) {
        this.saveRawData[key] = obj;
        this.setBehaviorExpr();
      },
      /**
       * 修改 relation操作
       * @param  {[String]} str [修改后的 relation]
       */
      choiceRelation(str) {
        this.behavior.relation = str;
      },
      /**
       * 添加指定的选项
       * @param {[String]} key [添加项的 itemKeyName]
       */
      addItemBox(key) {
        this.moduleItemName.push(key);
      },
    },
  };
</script>
